import { Injectable } from '@angular/core';
import { DataService } from './data.service';

@Injectable()
export class VehicleService {

    route = '/api/vehicle';

    constructor(private dataService: DataService) {
    };


    getStoppagehistory(data: any, refresh: boolean) {
        return this.dataService.getData('/api/tripentry/stoppagehistory/' + data.vehicleId + '/' + data.start + '/' + data.end, refresh);
    }
    getTripEvents(vehicleId, startTs, endTs, refresh) {
        return this.dataService.getData('/api/event/eventList/' + vehicleId + '/' + startTs + '/' + endTs, refresh)
    }
    gettripTrackDets(data: any) {
        return this.dataService.post('/api/tripTrackDets', data).map(response => {
            return response;
        });
    }

    getTripPlayBackDets(data, typeId: number) {
        if (typeId == 1) {
            return this.getDSTripPlayBackDets(data);
        }
        else if (typeId == 2) {
            return this.getTPTripPlayBackDets(data);
        }
    }

    getDSTripPlayBackDets(data) {
        return this.dataService.post('/api/getDSTripPlayBackDets', data).map(response => {
            return response;
        });
    }

    getTPTripPlayBackDets(data) {
        return this.dataService.post('/api/getTPTripPlayBackDets', data).map(response => {
            return response;
        });
    }

    getPlaybackDets(data) {
        return this.dataService.vtsPost('/web/gettrackingdata.php', data).map(response => {
            return response;
        });
    }


}
